import {
  Component, OnInit, ViewChild,
  AfterViewInit,
  ElementRef, ChangeDetectorRef, Input
} from '@angular/core';


import { Hotkey, HotkeysService } from 'angular2-hotkeys';
import { OnboardingPageService } from './onboarding-page.service';
import { PopUpMessageComponent } from '../pop-up-message/pop-up-message.component';

import { MatDialog, MatStepper } from '@angular/material';
import { ToastMessage } from '../toast-message/toast-message.service';

import { BreakpointObserver, Breakpoints, BreakpointState } from '@angular/cdk/layout';
// tslint:disable-next-line:import-blacklist
import { Observable } from 'rxjs/Rx';
import { map } from 'rxjs/operators';

import { ActivatedRoute, Router } from '@angular/router';

import { Ng4LoadingSpinnerService } from 'ng4-loading-spinner';
import { DataService } from '../data.service';
import { SigninService } from '../signin/signin.service';
import { LogService } from '../log-service.service';
import { CabService } from './cab-doc/cab.service';
import { CabComponent } from './cab-doc/cab.component';

type OnboardingBannerType = 'parcel' | 'pinkRider' | 'earlyActivation' | null;

declare let navigator;
@Component({
  selector: 'app-onboarding-page',
  template: require('./onboarding-page.component.html'),
  providers: [OnboardingPageService, ToastMessage, SigninService, LogService, CabService],
  styles: [`
    .optional-text {
      font-size: 12px;
      color: #666;
      font-weight: normal;
      margin-left: 2px;
      margin-right: 8px;
      display: inline-block;
    }
    .document-edit-blocker {
      color: #eb3323;
      font-size: 12px;
      margin-bottom: 12px;
    }
  `]
})
export class OnboardingPageComponent implements OnInit {
  isHandset$: Observable<boolean> = this.breakpointObserver.observe(Breakpoints.Handset)
    .pipe(
      map(result => result.matches)
    );
  public data: any;

  public userIdentity = {
    userId: '',
    mobile: '',
  };
  public config: any;
  public currentPage = 0;
  public riderId: any;
  public fleetId: any;
  public fleetMode: any;
  public fleetModeId: any;
  public fleetNumber: any;
  public showBasicInfo = true;
  public showProfilePic = false;
  public showDriversLicence = false;
  public showRC = false;
  public showPanOrAadhar = false;
  public showPan = false;
  public selectedRCRoadTaxButton = 'RC';
  private isRCRoadTaxToggleInitialized = false;
  public hasRoadTax = false;
  public rcDocumentStatus = '';
  public roadTaxDocumentStatus = '';
  public rcRoadTaxEditRestrictionConfig: any;
  public showPermit = false;
  public showFitness = false;
  public showInsurance = false;
  public isModeCar = false;
  public isFleetOnboarding = false;
  public selectedMatButton = '';
  public showMoreInfo = false;
  public showLogs = false;
  public stepperValue = 0;
  public userpreferences: any;
  public isErickshawType = false; // Track if mode is auto AND type is e-rickshaw for optional text
  public optionalDocs: string[] = [];
  public pages: any[] = ['Basic info', 'Profile Picture', 'Drivers license', 'Registration card',
    'PAN/Aadhar', 'Review'];
  public cabPages: any[] = ['Permit', 'Fitness', 'Insurance'];
  public documentMapping = {
    profilePicture: { type: 'profilePicture', display: 'Profile Picture' },
    driverLicense: { type: 'license', display: 'Driving License' },
    registrationCard: { type: 'rc', display: 'Registration Card' },
    roadTax: { type: 'roadTax', display: 'Road Tax' },
    panCard: { type: 'panCard', display: 'Pan' },
    aadhar: { type: 'aadhar', display: 'Aadhar' },
    permit: { type: 'permit', display: 'Permit' },
    fitness: { type: 'fitness', display: 'Fitness' },
    insurance: { type: 'insurance', display: 'Insurance' },
  };
  public registrationCard = 'Registration card';
  public isApproved: any[] = [];
  public pageName: any;
  public showDLBack = false;
  public showDLFront = true;
  tlAnnounced = false;
  public showRCBack = false;
  public showRCFront = true;
  public showPanBack = false;
  public showPanFront = true;
  public showAadharBack = false;
  public showAadharFront = true;

  public ppVerified = false;
  public dlVerified = false;
  public rcVerified = false;
  public roadTaxVerified = false;
  public panVerified = false;
  public aadharVerified = false;

  public showPPRejectIcon = false;
  public showRCRejectIcon = false;
  public showRoadTaxRejectIcon = false;
  public showDLRejectIcon = false;
  public showPanRejectIcon = false;
  public showAadharRejectIcon = false;

  public showActive = false;

  public stepperIndex = 0;
  public cities = [];
  public TLList = [];
  public vehiclesId = 0;
  public userLoggedIn: any;
  public approvedPages = [];
  public vehicleData: any;
  public loggedInUser = '';
  public internetSpeed: any;
  public internetSubscriber: any;
  public slowInternet = false;
  public noInternet = false;
  public internetSpeeds = ['4g', '3g'];
  // doc verifivation
  public licenseData = {};
  public pan = {};
  public aadhar = {};
  public profileData;
  public vehicleRegistrationData = {};
  public basicInfo = {};
  public showVerifyButton = false;
  public licenseStatus: any;
  public profileStatus: any;
  public vehicleRegStatus: any;
  public roadTaxRegStatus: any;
  public panStatus: any;
  public aadharStatus: any;
  public vehicleRegistrationStatus: any;
  public actorId: any;
  public riderData: any;

  // permission base editing
  public allowEditing = false;
  public allowMobileEdit = false;
  public allowFleetEdit = false;

  // verify button for individual docs
  public showPPVerify = false;
  public showDLVerify = false;
  public showRCVerify = false;
  public showRoadTaxVerify = false;
  public showPanVerify = false;
  public showAadharVerify = false;
  public modes = [];

  public dlNumber: any;
  public vehicleNumber: any;
  public aadharNumber: any;
  public panNumber: any;
  public showBulkRejectionPanel = false;
  public bulkRejectDocuments = [];
  public rejectedDocsToShowInPanel = [];
  public isProfileRejected = false;
  public isDlRejected = false;
  public isRCRejected = false;
  public isRoadTaxRejected = false;
  public isPermitDeleted = false;
  public isPermitRejected = false;
  public isPermitApproved = false;
  public isInsuranceDeleted = false;
  public isInsuranceRejected = false;
  public isInsuranceApproved = false;
  public isFitnessDeleted = false;
  public isFitnessRejected = false;
  public isFitnessApproved = false;
  public isPanRejected = false;
  public isAadharRejected = false;
  public isImageOptional = false;
  public isPermitImageOptional: boolean = true;
  public isFitnessImageOptional: boolean = true;
  public isInsuranceImageOptional: boolean = true;
  public isAadharOtpRequired = false;
  public isAadharBackOptional = false;
  public isFleetAttached = false;
  public userId: any;
  public isEarlyActivationEnabled = false;
  public isPanUploadAllowed = true;
  public verificationAndApprovalText = '';
  public notMandatoryDocLabels: string[] = [];
  public isDrivingLicenseOptionalInEarlyActivation = true;
  public isBikePinkEarlyActivationV2 = false;
  private earlyActivationDocUniverse = ['rc', 'aadhar', 'driving_license'];
  public isPinkRiderBannerEnabled = false;
  public pinkRiderHeader = '';
  public pinkRiderFemaleEligibleMessage = '';
  public pinkRiderMaleOthersEligibleMessage = '';
  public parcelBannerHeader = '';
  public parcelBannerLine1 = '';
  public parcelBannerLine2 = '';
  public activeOnboardingBanner: OnboardingBannerType = null;

  public rcDefaulter = false;
  public rcDefaulterNumberChanged = false;
  public showVehicleNumberChangeToggle = true;

  public verificationStatus = {
    ACCEPTED: 'Accepted',
    WARNING: 'Warning',
    REJECTED: 'Rejected',
    VERIFIED: 'Verified'
  };

  private readonly defaultRcRoadTaxEditRestrictionConfig = {
    enabled: true,
    documents: {
      rc: 'RC',
      roadTax: 'Road Tax'
    },
    mutualEditableStatuses: [
      'processing',
      'docUploaded'
    ],
    selfEditable: [
      'approved'
    ],
    counterpartBlocking: [
      'processing',
      'docUploaded',
      'approved'
    ],
    blockedMessage: '{sourceLabel} is currently in {sourceStatus}. '
      + 'Reject the {sourceLabel} before allowing {targetLabel} upload/update.'
  };

  public ACTORTYPE = {
    AGENT: 'Agent'
  };

  public panVerificationDetails = {};
  public aadharVerificationDetails = {};
  public cabDocList = ['permit', 'insurance', 'fitness'];

  @ViewChild('stepper') stepper: MatStepper;
  @ViewChild('permitComponent') permitComponent: CabComponent;
  @ViewChild('fitnessComponent') fitnessComponent: CabComponent;
  @ViewChild('insuranceComponent') insuranceComponent: CabComponent;

  constructor(
    private breakpointObserver: BreakpointObserver,
    private _changeDetector: ChangeDetectorRef,
    private _hotkeysService: HotkeysService,
    private _onboardingService: OnboardingPageService,
    private _toastMessage: ToastMessage,
    private route: ActivatedRoute,
    private router: Router,
    private dataService: DataService,
    private spinnerService: Ng4LoadingSpinnerService,
    private logService: LogService,
    private dialog: MatDialog,
    private _logService: LogService,
    private _cabService: CabService,
  ) {
    const cookies = document.cookie.split(';');

    const userCookie = cookies.find(function (item) {
      return item.includes('name');
    });
    if (userCookie) {
      this.loggedInUser = userCookie.split('=')[1];

    } else {
      alert('Please login again. Cookies not found');
      this.router.navigate(['/']);
    }
    this._hotkeysService.add(new Hotkey('left', (event: KeyboardEvent): boolean => {
      document.getElementById('backButton').click();
      return false; // Prevent bubbling
    }));
    this._hotkeysService.add(new Hotkey('right', (event: KeyboardEvent): boolean => {
      document.getElementById('nextButton').click();
      return false; // Prevent bubbling
    }));
    this._hotkeysService.add(new Hotkey(['b', 'B'], (event: KeyboardEvent): boolean => {
      this.stepperIndex = 0;
      return false; // Prevent bubbling
    }));
    this._hotkeysService.add(new Hotkey(['p', 'P'], (event: KeyboardEvent): boolean => {
      this.stepperIndex = 1;
      return false; // Prevent bubbling
    }));
    this._hotkeysService.add(new Hotkey(['d', 'D'], (event: KeyboardEvent): boolean => {
      this.stepperIndex = 2;
      return false; // Prevent bubbling
    }));
    this._hotkeysService.add(new Hotkey(['r', 'R'], (event: KeyboardEvent): boolean => {
      this.stepperIndex = 3;
      return false; // Prevent bubbling
    }));
    this._hotkeysService.add(new Hotkey(['a', 'A'], (event: KeyboardEvent): boolean => {
      this.stepperIndex = 5;
      return false; // Prevent bubbling
    }));
    this._hotkeysService.add(new Hotkey(['i', 'I'], (event: KeyboardEvent): boolean => {
      this.stepperIndex = 4;
      return false; // Prevent bubbling
    }));
    this._hotkeysService.add(new Hotkey(['shift+b', 'shift+B'], (event: KeyboardEvent): boolean => {
      this.backToSearchPage();
      return false; // Prevent bubbling
    }));
    this._hotkeysService.add(new Hotkey(['shift+r', 'shift+R'], (event: KeyboardEvent): boolean => {
      this.reloadRiderData();
      return false; // Prevent bubbling
    }));

    this.pageName = this.pages[this.currentPage];
  }

  ngOnInit() {
    this.dataService.toBeReload = true;
    const accessRoles = this.dataService.accessCookie('accessRoles');
    const splitRoles = accessRoles.split(',');
    if (splitRoles.indexOf('edit_captain') > -1) {
      this.allowEditing = true; // allow user to edit captain details
      if (splitRoles.indexOf('edit_captain_mobile') > -1) {
        this.allowMobileEdit = true;
      }
      if (splitRoles.indexOf('edit_fleet_attach_detach_access') > -1) {
        this.allowFleetEdit = true;
      }
    }
    this.riderId = this.route.snapshot.queryParamMap.get('id');
    if (!this.riderId) {
      this.riderId = this.route.snapshot.queryParamMap.get('phone');
    }
    this.fleetId = this.route.snapshot.queryParamMap.get('fleetId');
    this.fleetNumber = this.route.snapshot.queryParamMap.get('number');
    this.fleetMode = this.route.snapshot.queryParamMap.get('mode');
    if (this.fleetId && this.fleetNumber && this.fleetMode) {
      this.isFleetOnboarding = true;
      this.isModeCar = this.fleetMode === 'Car'
      this.fleetModeId = this.route.snapshot.queryParamMap.get('modeId');
      this.getFleetVehicleData(this.fleetId, this.fleetNumber, this.fleetMode, this.fleetModeId);
      this.isModeCar = this.fleetMode === 'Car'
      this.currentPage = 3;
      this.pageName = this.pages[this.currentPage];
      this.showBasicInfo = false;
      this.showProfilePic = false;
      this.showDriversLicence = false;
      this.showRC = true;
      this.showPanOrAadhar = false;
      this.showMoreInfo = false;
      this.showPermit = false;
      this.showFitness = false;
      this.showInsurance = false;
    } else {
      this.getRiderData(this.riderId);
      this.getCitiesList();
      this.getTLList();
      this.checkInternet();
      this.findLoggedInUser();
    }
  }

  findLoggedInUser() {
    const cookies = document.cookie.split(';');
    for (let i = 0; i < cookies.length; i++) {
      if (cookies[i].includes('_id')) {
        this.actorId = JSON.parse(cookies[i])['_id'];
      }
    }
  }

  checkInternet() {
    this.internetSubscriber = Observable.interval(2000).subscribe(() => {
      if (!navigator.onLine) {
        this.noInternet = true;
      } else {
        this.noInternet = false;
      }
      if (this.internetSpeeds.indexOf(navigator.connection.effectiveType) < 0) {
        this.slowInternet = true;
        this.internetSpeed = navigator.connection.effectiveType;
      } else {
        this.slowInternet = false;
      }
    });
  }

  addDocumentToRejectList(event) {
    if (!this.showBulkRejectionPanel) { this.showBulkRejectionPanel = true; }

    const imageTypeToReject = event.imageType, imageViewToReject = event.view;
    event.displayName = this.documentMapping[imageTypeToReject].display;
    if (event.imageType == 'registrationCard') {
      if (event.isImageOptional) {
        if (!this.rcDefaulterNumberChanged) {
          event.removeRcData = false;
        } else {
          event.removeRcData = true;
        }
      }
    }
    const docFromList = this.bulkRejectDocuments.filter(
      (doc) => doc.imageType === imageTypeToReject && doc.view === imageViewToReject
    );
    if (docFromList.length === 0) { this.bulkRejectDocuments.push(event); }
    this.bulkRejectDocuments.map((doc) => {
      const display = this.documentMapping[doc.imageType].display;
      if (!this.rejectedDocsToShowInPanel.includes(display)) {
        this.rejectedDocsToShowInPanel.push(this.documentMapping[doc.imageType].display);
      }
    });
  }

  removeDocsFromBulkRejection(document) {
    const displayIndex = this.rejectedDocsToShowInPanel.findIndex((doc) => doc === document);
    this.rejectedDocsToShowInPanel.splice(displayIndex, 1);
    const docIndex = this.bulkRejectDocuments.findIndex((doc) => doc.displayName === document);
    this.bulkRejectDocuments.splice(docIndex, 1);
    if (this.bulkRejectDocuments.length === 0) { this.showBulkRejectionPanel = false; }
  }

  assignKeysForCabMode() {
    this._hotkeysService.add(new Hotkey(['e', 'E'], (event: KeyboardEvent): boolean => {
      this.stepperIndex = 5;
      return false; // Prevent bubbling
    }));
    this._hotkeysService.add(new Hotkey(['f', 'F'], (event: KeyboardEvent): boolean => {
      this.stepperIndex = 6;
      return false; // Prevent bubbling
    }));
    this._hotkeysService.add(new Hotkey(['s', 'S'], (event: KeyboardEvent): boolean => {
      this.stepperIndex = 7;
      return false; // Prevent bubbling
    }));
    this._hotkeysService.add(new Hotkey(['a', 'A'], (event: KeyboardEvent): boolean => {
      this.stepperIndex = 8;
      return false; // Prevent bubbling
    }));
  }

  viewDetailsForRejectDocs() {
    const dialogRef = this.dialog.open(PopUpMessageComponent, {
      width: '550px',
      data: {
        options: [],
        title: 'Please confirm for the rejected documents',
        message: '',
        data: {
          type: 'orderedList', info: this.rejectedDocsToShowInPanel,
          note: 'The above documents will be rejected once you confirm'
        },
        reason: 'bulkRejectDocs',
        buttonText: 'Confirm',
        cancelText: 'Go Back',
        styles: {
          title: 'font-size-20 margin-bottom-30',
          actionClass: 'doc-rejection-confirm',
          note: 'margin-bottom-12 margin-top-30 color-grey'
        }
      }
    });

    dialogRef.afterClosed().subscribe(confirm => {
      if (confirm) {
        this.bulkRejectDocs();
      }
    });
  }

  updatePermitVars() {
    this.isPermitRejected = true;
    this.isPermitApproved = false;
    this.isPermitDeleted = true;
  }

  updateFitnessVars() {
    this.isFitnessRejected = true;
    this.isFitnessApproved = false;
    this.isFitnessDeleted = true;
  }

  updateInsuranceVars() {
    this.isInsuranceRejected = true;
    this.isInsuranceApproved = false;
    this.isInsuranceDeleted = true;
  }

  rejectCabDocs(cabRejectedDocs, isOnlyCabDocRejected) {
    const body = {};
    body['documents'] = [];
    let permitToBeDeleted = false;
    let fitnessToBeDeleted = false;
    let insuranceToBeDeleted = false;
    for (let index = 0; index < cabRejectedDocs.length; index++) {
      body['userId'] = cabRejectedDocs[index].userId;
      body['source'] = "supply-dashboard";
      if (this.fleetId) {
        body['fleetId'] = this.fleetId;
      }
      if (this.fleetNumber) {
        body['fleetNumber'] = this.fleetNumber
      }
      body['documents'].push({
        'data': cabRejectedDocs[index].data,
        'imageType': cabRejectedDocs[index].imageType,
        'userId': cabRejectedDocs[index].userId,
        'view': 'front',
        'fleetNumber': this.fleetNumber
      });
      if (cabRejectedDocs[index].imageType === 'permit') {
        permitToBeDeleted = true;
      }
      if (cabRejectedDocs[index].imageType === 'fitness') {
        fitnessToBeDeleted = true;
      }
      if (cabRejectedDocs[index].imageType === 'insurance') {
        insuranceToBeDeleted = true;
      }
    }
    this._cabService.rejectCabDocs('', body).subscribe(
      response => {
        if (permitToBeDeleted) {
          this.updatePermitVars();
          // Reset the permit component UI
          if (this.permitComponent) {
            this.permitComponent.resetImageViewUI();
          }
        }
        if (fitnessToBeDeleted) {
          this.updateFitnessVars();
          // Reset the fitness component UI
          if (this.fitnessComponent) {
            this.fitnessComponent.resetImageViewUI();
          }
        }
        if (insuranceToBeDeleted) {
          this.updateInsuranceVars();
          // Reset the insurance component UI
          if (this.insuranceComponent) {
            this.insuranceComponent.resetImageViewUI();
          }
        }

        // Refresh cab data to get updated state after rejection
        if (this.isFleetOnboarding) {
          this.fetchCabData(this.fleetId, this.fleetNumber);
        } else {
          this.fetchCabData(this.riderId, "");
        }

        if (isOnlyCabDocRejected) {
          this.spinnerService.hide();
          this.showSuccessfulRejectionPopup();
        }
      },
      error => {
        console.log('Error in rejectCabDocs');
        console.log(error);
        const errorMsg = error && typeof error === 'string' ? error : 'Failed to reject cab docs. Please try again.';
        this.spinnerService.hide();
        this._toastMessage.openSnackBarError(errorMsg);
      }
    );
  }

  showSuccessfulRejectionPopup() {
    let message = 'has been rejected successfully';
    this.rejectedDocsToShowInPanel.length > 1 ? message = ' has been rejected successfully' : message;

    const dialogRef = this.dialog.open(PopUpMessageComponent, {
      width: '550px',
      data: {
        options: [],
        title: `${this.rejectedDocsToShowInPanel.join(', ')} ${message}`,
        message: '',
        singleButton: true,
        reason: 'doccumentsRejected',
        buttonText: 'Okay',
        styles: {
          title: 'font-size-18 margin-bottom-30 text-align-center',
          actionClass: 'popup-okay-button',
        }
      }
    });

    dialogRef.afterClosed().subscribe(confirm => {
      this.rejectedDocsToShowInPanel = [];
    });
  }

  isRejectedDocCabDoc(docType) {
    return this.cabDocList.includes(docType);
  }

  getRejectedDocsArray(bulkRejectDocuments) {
    const originalRejectedDocs = [];
    const cabDocs = [];

    for (let index = 0; index < bulkRejectDocuments.length; index++) {
      if (this.isRejectedDocCabDoc(bulkRejectDocuments[index].imageType)) {
        cabDocs.push(bulkRejectDocuments[index]);
      } else { originalRejectedDocs.push(bulkRejectDocuments[index]); }
    }
    return { originalRejectedDocs, cabDocs };
  }

  bulkRejectDocs() {
    this.spinnerService.show();
    const { originalRejectedDocs, cabDocs } = this.getRejectedDocsArray(this.bulkRejectDocuments);
    this.bulkRejectDocuments = [];

    if (cabDocs.length != 0) {
      this.rejectCabDocs(cabDocs, originalRejectedDocs.length == 0);
    }

    if (originalRejectedDocs.length != 0) {
      this._onboardingService.bulkRejectDocs(originalRejectedDocs, this.userId, this.fleetId, this.fleetNumber).subscribe((response: any) => {
        this.spinnerService.hide();
        const rejectEvents = [];
        const docTypeMapping = {
          'profilePicture': 2,
          'driverLicense': 3,
          'registrationCard': 4,
          'panCard': 10,
          'aadhar': 11
        };

        originalRejectedDocs.map((doc) => {

          const docType = docTypeMapping[doc.imageType];
          switch (doc.imageType) {
            case 'profilePicture': { this.isProfileRejected = true; break; }
            case 'driverLicense': { this.isDlRejected = true; break; }
            case 'registrationCard': { this.isRCRejected = true; break; }
            case 'roadTax': { this.isRoadTaxRejected = true; break; }
            case 'panCard': { this.isPanRejected = true; break; }
            case 'aadhar': { this.isAadharRejected = true; break; }
          }

          this.showBulkRejectionPanel = false;

          rejectEvents.push({
            metaData: {
              View: doc.view,
              Status: 'REJECTED',
              ImageType: doc.displayName,
              RejectReason: doc.data,
            },
            docType
          });
        });

        this.showSuccessfulRejectionPopup();

      }, error => {
        console.log('Error in Bulk Rejections');
        console.log(error);
        this.showBulkRejectionPanel = false;
        this.rejectedDocsToShowInPanel = [];
        const errorMsg = error && typeof error === 'string' ? error : 'Failed to reject the docs. Please try again.';
        this.spinnerService.hide();
        this._toastMessage.openSnackBarError(errorMsg);
      });
    }

  }

  formDocStatusInfo() {
    let vehicleData;
    this.licenseData['drivingLicense'] = this.data && this.data['license'] ? this.data['license'].number : '';
    this.licenseData['dlImage'] = this.data && this.data['license'] ? this.data['license'].frontLink : '';
    this.licenseData['dlBackImage'] = this.data && this.data['license'] ? this.data['license'].backLink : '';

    if (this.data.vehiclesAssignable[0] && this.data.vehiclesAssignable.length > 1) {
      const index = this.data.vehiclesAssignable.length - 1;
      vehicleData = this.data.vehiclesAssignable[index].id && this.data.vehiclesAssignable[index].id.vehicleNumber ?
        this.data.vehiclesAssignable[index].id.vehicleNumber : '';
    }
    if (this.data.vehiclesAssignable[0] && this.data.vehiclesAssignable.length === 1) {
      vehicleData = this.data.vehiclesAssignable[0] && this.data.vehiclesAssignable[0].id &&
        this.data.vehiclesAssignable[0].id.vehicleNumber ? this.data.vehiclesAssignable[0].id.vehicleNumber : '';
    }
    this.vehicleRegistrationData['registrationNumber'] = vehicleData;
    const dob = this.data && this.data['license'] && this.data && this.data['license'].dob;
    const date = dob ? new Date(dob) : null;
    this.licenseData['birthDate'] = date && date.getFullYear() !== 1 ? date : '';
    this.basicInfo['firstName'] = this.data && this.data.firstName || '';
    this.profileData = {
      'profileImage': this.data && this.data['profilePicture'] ? this.data['profilePicture'].link : ''
    };
    this.pan['number'] = this.data.pan ? this.data.pan.number : '';
    this.pan['image'] = this.data.pan ? this.data.pan.link : '';

    this.aadhar['number'] = this.data.aadhar ? this.data.aadhar.number : '';
    this.aadhar['frontLink'] = this.data.aadhar ? this.data.aadhar.frontLink : '';
    this.aadhar['backLink'] = this.data.aadhar ? this.data.aadhar.backLink : '';

  }

  async getRiderData(data) {
    let response;
    let dataObject, docStatus;
    this.spinnerService.show();
    await this.getModes();
    this._onboardingService.getRiderDetails(data).subscribe(async (resp) => {
      this.spinnerService.hide();
      response = resp;
      dataObject = response.data;
      this.updateOnboardingBanners(response, dataObject);
      if (response && response.data && !response.data.userId) {
        this._toastMessage.openSnackBarError('User details not available for  this captain');
        return;
      }
      this.updateCabDocOptionalFlags(dataObject);
      if (dataObject.fleetId) {
        this.isFleetAttached = true;
        this.pages = this.pages.filter(page => !this.registrationCard.includes(page));
      }
      if (dataObject.modeId && dataObject.modeId.mode === 'Car') {
        this.isModeCar = true;
        this.fetchCabData(dataObject._id, "");
        this.assignKeysForCabMode();
        this.pages = [...this.pages.slice(0, this.pages.length - 1), ...this.cabPages, this.pages[this.pages.length - 1]];
      } else {
        this.isModeCar = false;
        this.pages = this.pages.filter(page => !this.cabPages.includes(page));
      }
      docStatus = dataObject['docVerificationStatus'] || {};
      this.createDlStatus(docStatus);
      this.createProfileStatus(docStatus);
      this.createRcStatus(docStatus);
      // this.createPanStatus(docStatus);
      // this.createAadharStatus(docStatus);
      this.userIdentity.mobile = dataObject.mobile;
      this.userIdentity.userId = dataObject._id;
      this.userId = dataObject._id;
      if (dataObject.registeredCity == null) {
        dataObject.registeredCity = '';
      }
      this.showPan = this.isPanUploadAllowed && (!!(dataObject.panCard && dataObject.panCard.link) || dataObject.active);
      this.selectedMatButton = this.showPan ? 'Pan' : 'Aadhar';
      if (dataObject.profilePicture && dataObject.profilePicture) {
        this.setProfileStatus(
          dataObject.profilePicture.verified, dataObject.profilePicture.rejectRemarks, dataObject.profilePicture.status
        );
      }
      if (dataObject.license && dataObject.license) {
        this.setDlStatus(
          dataObject.license.verified, dataObject.license.rejectRemarks, dataObject.license.status
        );
      }
      if (dataObject.panCard) {
        this.setPanStatus(
          dataObject.panCard.verified, dataObject.panCard.rejectRemarks, dataObject.panCard.status
        );
        this.createPanInfo();
      }
      if (dataObject.aadhar) {
        this.setAadharStatus(
          dataObject.aadhar.verified, dataObject.aadhar.rejectRemarks, dataObject.aadhar.status
        );
        this.createAadharInfo();
      }
      if (dataObject.vehiclesAssignable
        && dataObject.vehiclesAssignable[dataObject.vehiclesAssignable.length - 1]
        && dataObject.vehiclesAssignable[0].id) {
        const rc = dataObject.vehiclesAssignable[0].id.rc;
        if (rc) {
          this.rcDocumentStatus = this.getDocumentStatus(rc, rc.verified);
          this.setRcStatus(rc.verified, rc.rejecteRemarks, rc.status);
          this.setImageOptionalFlag(rc);
        } else {
          this.rcDocumentStatus = '';
        }
      } else {
        this.rcDocumentStatus = '';
      }
      if (dataObject.aadhar) {
        this.setAadhaarOtpRequiredFlag(dataObject.aadhar);
        this.setAadharBackOptionalFlag(dataObject.aadhar);
      }
      // Initialize RC/RoadTax toggle - default to RC if it exists, otherwise RoadTax
      // Only set on initial load, preserve user's selection on subsequent reloads
      const hasRC = !!(dataObject.vehiclesAssignable && dataObject.vehiclesAssignable.length > 0);
      const hasRoadTax = !!(dataObject.roadTax);
      this.hasRoadTax = hasRoadTax;
      // Only initialize on first load, preserve user's selection on subsequent reloads
      if (!this.isRCRoadTaxToggleInitialized) {
        this.selectedRCRoadTaxButton = hasRC ? 'RC' : (hasRoadTax ? 'RoadTax' : 'RC');
        this.isRCRoadTaxToggleInitialized = true;
      } else {
        // Preserve current selection, but validate it exists
        if (this.selectedRCRoadTaxButton === 'RoadTax' && !hasRoadTax && hasRC) {
          // If user selected RoadTax but it doesn't exist, fall back to RC
          this.selectedRCRoadTaxButton = 'RC';
        } else if (this.selectedRCRoadTaxButton === 'RC' && !hasRC && hasRoadTax) {
          // If user selected RC but it doesn't exist, fall back to RoadTax
          this.selectedRCRoadTaxButton = 'RoadTax';
        }
        // Otherwise, keep the current selection
      }
      if (dataObject.roadTax) {
        const roadTax = dataObject.roadTax;
        // Check if roadTax has verified status or status field
        const roadTaxVerified = roadTax.verified || (roadTax.status === 'approved');
        const roadTaxRejectRemarks = roadTax.rejectRemarks || roadTax.rejecteRemarks;
        const roadTaxStatus = roadTax.status || (roadTaxVerified ? 'approved' : 'processing');
        this.roadTaxDocumentStatus = this.getDocumentStatus(roadTax, roadTaxVerified);
        this.setRoadTaxStatus(roadTaxVerified, roadTaxRejectRemarks, roadTaxStatus);
        // Create road tax verification status from verificationInfo
        this.createRoadTaxStatus(roadTax);
        this.hasRoadTax = true;
        // Update verify button visibility based on RoadTax number
        if (this.canShowVerifyButtons(dataObject)) {
          const roadTaxVehicleNumber = this.getRoadTaxVehicleNumber();
          this.showRoadTaxVerify = !!roadTaxVehicleNumber;
        }
      } else {
        this.hasRoadTax = false;
        this.roadTaxDocumentStatus = '';
        this.showRoadTaxVerify = false;
      }
      if (dataObject.active === true) {
        this.showActive = true;
      } else {
        this.showActive = false;
      }
      this.data = dataObject;
      this.data.modes = this.modes;
      // Initialize isErickshawType flag based on current mode AND type
      const currentMode = this.data.modeId && this.data.modeId.mode;
      this.isErickshawType = (currentMode === 'Auto' && this.data.type === 'Erickshaw');
      await this.fetchTypeConfig();

      // Active noDl captains still use document status to determine visibility
      if (!this.canShowVerifyButtons()) {
        this.showDLVerify = false;
        this.showPPVerify = false;
        this.showRCVerify = false;
        this.showRoadTaxVerify = false;
        this.showPanVerify = false;
        this.showAadharVerify = false;
      } else {
        this.verifyStatus(this.data);
        this.formDocStatusInfo();
      }
      this.fetchRcDefaulter(this.userId);
      this.checkData(this.data);
    },
      err => {
        this.spinnerService.hide();
        this._toastMessage.openSnackBarError('Could not fetch rider details');
        console.log(err);
      });
  }

  async getFleetVehicleData(fleetId, number, mode, modeId) {
    let response;
    let dataObject, docStatus;
    this.spinnerService.show();
    this._onboardingService.getFleetVehicleDetails(fleetId, number).subscribe(resp => {
      this.spinnerService.hide();
      this.updateOnboardingBanners(resp, resp && resp['data']);
      if (resp["data"]) {
        resp["data"]["mode"] = mode
        resp["data"]["modeId"] = {
          "_id": modeId,
          "mode": mode
        }
      }
      response = resp;
      dataObject = response.data;
      if (mode === 'Car') {
        this.fetchCabData(fleetId, number);
        this.assignKeysForCabMode()
        this.pages = ['Registration card', 'Permit', 'Fitness', 'Insurance'];
      } else {
        this.pages = ['Registration card'];
      }
      docStatus = dataObject['docVerificationStatus'] || {};
      this.createRcStatus(docStatus);
      this.userIdentity.userId = fleetId;
      this.userId = fleetId;

      if (
        dataObject.vehiclesAssignable
        && dataObject.vehiclesAssignable[dataObject.vehiclesAssignable.length - 1]
        && dataObject.vehiclesAssignable[0].id
      ) {
        const rc = dataObject.vehiclesAssignable[0].id.rc;
        if (rc) {
          this.rcDocumentStatus = this.getDocumentStatus(rc, rc.verified);
          this.setRcStatus(rc.verified, rc.rejecteRemarks, rc.status);
          this.setImageOptionalFlag(rc);
        } else {
          this.rcDocumentStatus = '';
        }
      } else {
        this.rcDocumentStatus = '';
      }
      if (dataObject.roadTax) {
        const roadTax = dataObject.roadTax;
        // Check if roadTax has verified status or status field
        const roadTaxVerified = roadTax.verified || (roadTax.status === 'approved');
        const roadTaxRejectRemarks = roadTax.rejectRemarks || roadTax.rejecteRemarks;
        const roadTaxStatus = roadTax.status || (roadTaxVerified ? 'approved' : 'processing');
        this.roadTaxDocumentStatus = this.getDocumentStatus(roadTax, roadTaxVerified);
        this.setRoadTaxStatus(roadTaxVerified, roadTaxRejectRemarks, roadTaxStatus);
        // Create road tax verification status from verificationInfo
        this.createRoadTaxStatus(roadTax);
        this.hasRoadTax = true;
      } else {
        this.hasRoadTax = false;
        this.roadTaxDocumentStatus = '';
      }
      this.data = dataObject;
      this.data.modes = this.modes;

      this.verifyStatus(this.data);
      this.formDocStatusInfo();

      this.checkDataForFleet(this.data);
    },
      err => {
        this.spinnerService.hide();
        this._toastMessage.openSnackBarError('Could not fetch vehicle details');
        console.log(err);
      });
  }

  updateOnboardingBanners(response: any, dataObject: any) {
    this.resetOnboardingFlowState();

    const earlyActivationConfig = this.getEarlyActivationConfig(response, dataObject);
    const onboardingBanner = this.getOnboardingBanner(response, dataObject);

    // Server resolves onboardingBanner on /show — do not fall back to legacy client logic.
    if (onboardingBanner !== undefined && onboardingBanner !== null) {
      const bikePinkEarlyActivationV2 = this.isBikePinkEarlyActivationConfig(earlyActivationConfig);
      if (bikePinkEarlyActivationV2) {
        this.applyEarlyActivationConfig(earlyActivationConfig);
      } else if (
        onboardingBanner.activeBanner === 'earlyActivation'
        && this.hasEarlyActivationEnabled(earlyActivationConfig)
      ) {
        this.applyEarlyActivationConfig(earlyActivationConfig);
      }

      if (onboardingBanner.activeBanner) {
        this.applyOnboardingBanner(onboardingBanner);
      }
      return;
    }

    // Legacy fallback for /show responses without onboardingBanner.
    if (this.hasEarlyActivationEnabled(earlyActivationConfig)) {
      this.applyEarlyActivationConfig(earlyActivationConfig);
    }

    this.applyOnboardingBannerFromShowResponse(earlyActivationConfig, response, dataObject);
  }

  resetOnboardingFlowState() {
    this.activeOnboardingBanner = null;
    this.parcelBannerHeader = '';
    this.parcelBannerLine1 = '';
    this.parcelBannerLine2 = '';
    this.isPinkRiderBannerEnabled = false;
    this.pinkRiderHeader = '';
    this.pinkRiderFemaleEligibleMessage = '';
    this.pinkRiderMaleOthersEligibleMessage = '';

    this.isEarlyActivationEnabled = false;
    this.isPanUploadAllowed = true;
    this.verificationAndApprovalText = '';
    this.notMandatoryDocLabels = [];
    this.isDrivingLicenseOptionalInEarlyActivation = true;
    this.isBikePinkEarlyActivationV2 = false;
    this.updatePanAadharStepLabel('PAN/Aadhar');
  }

  updatePanAadharStepLabel(stepLabel: string) {
    const panAadharIndex = this.pages.findIndex((page) => page === 'PAN/Aadhar' || page === 'Aadhar');
    if (panAadharIndex === -1 || this.pages[panAadharIndex] === stepLabel) {
      return;
    }

    this.pages[panAadharIndex] = stepLabel;
    if (this.currentPage === panAadharIndex) {
      this.pageName = stepLabel;
    }
  }

  getOnboardingBanner(response: any, dataObject: any) {
    return (
      (response && response.data && response.data.onboardingBanner) ||
      (dataObject && dataObject.onboardingBanner) ||
      (response && response.onboardingBanner)
    );
  }

  applyOnboardingBanner(onboardingBanner: any) {
    const activeBanner = onboardingBanner.activeBanner;

    if (activeBanner === 'parcel') {
      const parcelMessages = onboardingBanner.parcelMessages || {};
      this.activeOnboardingBanner = 'parcel';
      this.parcelBannerHeader = parcelMessages.header || '';
      this.parcelBannerLine1 = parcelMessages.line1 || '';
      this.parcelBannerLine2 = parcelMessages.line2 || '';
      return;
    }

    if (activeBanner === 'pinkRider') {
      const pinkRiderMessages = onboardingBanner.pinkRiderMessages || {};
      this.activeOnboardingBanner = 'pinkRider';
      this.isPinkRiderBannerEnabled = true;
      this.pinkRiderHeader = pinkRiderMessages.header || '';
      this.pinkRiderFemaleEligibleMessage = pinkRiderMessages.female || '';
      this.pinkRiderMaleOthersEligibleMessage = pinkRiderMessages.maleOthers || '';
      return;
    }

    if (activeBanner === 'earlyActivation') {
      this.activeOnboardingBanner = 'earlyActivation';
    }
  }

  applyOnboardingBannerFromShowResponse(
    earlyActivationConfig: any,
    response: any,
    dataObject: any
  ) {
    this.updatePinkRiderBanner(response, dataObject);

    const isEarlyActivationFlowEnabled = this.hasEarlyActivationEnabled(earlyActivationConfig);

    if (!isEarlyActivationFlowEnabled) {
      return;
    }

    if (!this.isPinkRiderBannerEnabled) {
      this.activeOnboardingBanner = 'earlyActivation';
    }
  }

  getEarlyActivationConfig(response: any, dataObject: any) {
    return (
      (response && response.data && response.data.earlyActivationConfig) ||
      (dataObject && dataObject.earlyActivationConfig) ||
      (response && response.earlyActivationConfig)
    );
  }

  hasEarlyActivationEnabled(earlyActivationConfig: any): boolean {
    return !!(earlyActivationConfig && earlyActivationConfig.enabled === true);
  }

  isBikePinkEarlyActivationConfig(earlyActivationConfig: any): boolean {
    return !!(
      earlyActivationConfig
      && earlyActivationConfig.enabled === true
      && earlyActivationConfig.configVersion === 2
    );
  }

  applyEarlyActivationConfig(earlyActivationConfig: any) {
    this.isEarlyActivationEnabled = true;
    this.isBikePinkEarlyActivationV2 = this.isBikePinkEarlyActivationConfig(earlyActivationConfig);

    const requiredDocs = Array.isArray(earlyActivationConfig.requiredDocs)
      ? earlyActivationConfig.requiredDocs
      : [];

    const normalizedRequiredDocs = requiredDocs
      .map((doc) => this.normalizeEarlyActivationDoc(doc))
      .filter((doc) => !!doc);
    this.isPanUploadAllowed = normalizedRequiredDocs.indexOf('pan') > -1;

    if (!this.isPanUploadAllowed) {
      this.showPan = false;
      this.selectedMatButton = 'Aadhar';
    }

    this.updatePanAadharStepLabel(this.isPanUploadAllowed ? 'PAN/Aadhar' : 'Aadhar');

    this.updateEarlyActivationBannerContent(requiredDocs);
  }

  updateEarlyActivationBannerContent(requiredDocs: string[]) {
    const normalizedRequiredDocs = requiredDocs
      .map((doc) => this.normalizeEarlyActivationDoc(doc))
      .filter((doc) => !!doc);

    const uniqueNormalizedRequiredDocs = normalizedRequiredDocs.filter((doc, index, arr) => arr.indexOf(doc) === index);

    const formattedRequiredDocs = uniqueNormalizedRequiredDocs
      .map((doc) => this.formatEarlyActivationDoc(doc))
      .filter((doc) => !!doc);

    const finalDocs = [...formattedRequiredDocs];
    if (!finalDocs.includes('Profile Pic')) {
      finalDocs.push('Profile Pic');
    }

    this.verificationAndApprovalText = finalDocs.length > 0
      ? finalDocs.join(' + ')
      : 'Profile Pic';

    this.notMandatoryDocLabels = this.earlyActivationDocUniverse
      .filter((doc) => uniqueNormalizedRequiredDocs.indexOf(doc) === -1)
      .map((doc) => this.formatEarlyActivationDoc(doc))
      .filter((doc) => !!doc);

    this.isDrivingLicenseOptionalInEarlyActivation = this.notMandatoryDocLabels.indexOf('Driving License') > -1;
  }

  updatePinkRiderBanner(response: any, dataObject: any) {
    const pinkRiderConfig = response && response.data && response.data.pinkRiderConfig;

    this.isPinkRiderBannerEnabled = !!(pinkRiderConfig && pinkRiderConfig.enabled === true);
    if (!this.isPinkRiderBannerEnabled) {
      this.pinkRiderHeader = '';
      this.pinkRiderFemaleEligibleMessage = '';
      this.pinkRiderMaleOthersEligibleMessage = '';
      return;
    }

    const messages = (pinkRiderConfig && pinkRiderConfig.messages) || {};

    this.pinkRiderHeader = messages.header || '';
    this.pinkRiderFemaleEligibleMessage = messages.female || '';
    this.pinkRiderMaleOthersEligibleMessage = messages.maleOthers || '';
  }

  normalizeEarlyActivationDoc(docType: string): string {
    const normalizedDocType = ((docType || '') + '').toLowerCase();
    switch (normalizedDocType) {
      case 'rc':
      case 'registrationcard':
      case 'registration_card':
      case 'registration-card':
        return 'rc';
      case 'pan':
      case 'pancard':
      case 'pan_card':
      case 'pan-card':
        return 'pan';
      case 'aadhar':
      case 'aadhaar':
        return 'aadhar';
      case 'dl':
      case 'license':
      case 'drivinglicense':
      case 'driving_license':
      case 'driving-license':
        return 'driving_license';
      case 'profile':
      case 'profilepicture':
      case 'profile_picture':
      case 'profile-picture':
      case 'profile pic':
      case 'profile_pic':
      case 'profile-pic':
        return 'profile_pic';
      default:
        return normalizedDocType;
    }
  }

  formatEarlyActivationDoc(docType: string): string {
    const normalizedDocType = this.normalizeEarlyActivationDoc(docType);
    switch (normalizedDocType) {
      case 'rc':
        return 'RC';
      case 'pan':
        return 'PAN';
      case 'aadhar':
        return 'Aadhaar';
      case 'driving_license':
        return 'Driving License';
      case 'profile_pic':
        return 'Profile Pic';
      default:
        return docType ? docType.toUpperCase() : '';
    }
  }

  updateCabDocOptionalFlags(dataObject: any) {
    const config = dataObject && dataObject.docsConfig;
    if (!config || !Array.isArray(config.docs) || !config.docs.length) {
      this.isPermitImageOptional = true;
      this.isFitnessImageOptional = true;
      this.isInsuranceImageOptional = true;
      return;
    }
    const flags = { permit: true, fitness: true, insurance: true };
    config.docs.forEach((item: any) => {
      flags[String(item.type).toLowerCase()] = !!(item.config && item.config.isImageOptional);
    });
    this.isPermitImageOptional = flags.permit;
    this.isFitnessImageOptional = flags.fitness;
    this.isInsuranceImageOptional = flags.insurance;
  }

  getCitiesList() {
    let response;
    this._onboardingService.getCitiesList().subscribe(resp => {
      response = resp;
      this.cities = response.geolayers;
    },
      err => {
        this._toastMessage.openSnackBarError('Could not retrieve list of cities');
        console.log(err);
      });
  }

  async getModes() {
    try {
      const response: any = await this._onboardingService.getModes(this.riderId).toPromise();
      if (response.data && response.data.modes) {
        this.modes = response.data.modes.data || [];
      }
    } catch (err) {
      console.log(err);
      this._toastMessage.openSnackBarError('Could not fetch modes');
    }
  }

  getTLList() {
    let response;
    this._onboardingService.getTLList().subscribe(resp => {
      response = resp;
      this.TLList = response.data && response.data.data || [];
    },
      err => {
        this._toastMessage.openSnackBarError('Could not fetch list of TLs');
        console.log(err);
      });
  }

  panAadharToggle(event) {
    if (event.value === 'Pan' && !this.isPanUploadAllowed) {
      this.showPan = false;
      this.selectedMatButton = 'Aadhar';
      return;
    }
    this.showPan = event.value === 'Pan' ? true : false;
  }

  rcRoadTaxToggle(event) {
    this.selectedRCRoadTaxButton = event.value;
  }

  stepClick(step, stepper: MatStepper) {
    this.currentPage = step.selectedIndex;

    step.previouslySelectedStep.interacted = false;
    this.pageName = this.pages[this.currentPage];

    if (this.isFleetAttached) {
      switch (step.selectedIndex) {
        case 0:
          this.showBasicInfo = true;
          this.showProfilePic = false;
          this.showDriversLicence = false;
          this.showPanOrAadhar = false;
          this.showMoreInfo = false;
          break;
        case 1:
          this.showBasicInfo = false;
          this.showProfilePic = true;
          this.showDriversLicence = false;
          this.showPanOrAadhar = false;
          this.showMoreInfo = false;
          break;
        case 2: this.showBasicInfo = false;
          this.showProfilePic = false;
          this.showDriversLicence = true;
          this.showPanOrAadhar = false;
          this.showMoreInfo = false;
          break;
        case 3: this.showBasicInfo = false;
          this.showProfilePic = false;
          this.showDriversLicence = false;
          this.showPanOrAadhar = true;
          this.showMoreInfo = false;
          break;
        case 4:
          this.showBasicInfo = false;
          this.showProfilePic = false;
          this.showDriversLicence = false;
          this.showPanOrAadhar = false;
          this.showMoreInfo = true;
          break;
      }
    } else if (this.isFleetOnboarding) {
      switch (step.selectedIndex) {
        case 0:
          this.showRC = true;
          this.showPermit = false;
          this.showFitness = false;
          this.showInsurance = false;
          break;
        case 1:
          this.showRC = false;
          this.showPermit = true;
          this.showFitness = false;
          this.showInsurance = false;
          break;
        case 2:
          this.showRC = false;
          this.showPermit = false;
          this.showFitness = true;
          this.showInsurance = false;
          break;
        case 3:
          this.showRC = false;
          this.showPermit = false;
          this.showFitness = false;
          this.showInsurance = true;
          break;
      }
    }
    else {
      switch (step.selectedIndex) {
        case 0:
          this.showBasicInfo = true;
          this.showProfilePic = false;
          this.showDriversLicence = false;
          this.showRC = false;
          this.showPanOrAadhar = false;
          this.showMoreInfo = false;
          this.showPermit = false;
          this.showFitness = false;
          this.showInsurance = false;
          break;
        case 1:
          this.showBasicInfo = false;
          this.showProfilePic = true;
          this.showDriversLicence = false;
          this.showRC = false;
          this.showPanOrAadhar = false;
          this.showMoreInfo = false;
          this.showPermit = false;
          this.showFitness = false;
          this.showInsurance = false;
          break;
        case 2: this.showBasicInfo = false;
          this.showProfilePic = false;
          this.showDriversLicence = true;
          this.showRC = false;
          this.showPanOrAadhar = false;
          this.showMoreInfo = false;
          this.showPermit = false;
          this.showFitness = false;
          this.showInsurance = false;
          break;
        case 3: this.showBasicInfo = false;
          this.showProfilePic = false;
          this.showDriversLicence = false;
          this.showRC = true;
          this.showPanOrAadhar = false;
          this.showMoreInfo = false;
          this.showPermit = false;
          this.showFitness = false;
          this.showInsurance = false;
          break;
        case 4:
          this.showBasicInfo = false;
          this.showProfilePic = false;
          this.showDriversLicence = false;
          this.showRC = false;
          this.showPanOrAadhar = true;
          this.showMoreInfo = false;
          this.showPermit = false;
          this.showFitness = false;
          this.showInsurance = false;
          break;
        case 5:
          if (this.isModeCar) {
            this.showBasicInfo = false;
            this.showProfilePic = false;
            this.showDriversLicence = false;
            this.showRC = false;
            this.showPanOrAadhar = false;
            this.showMoreInfo = false;
            this.showPermit = true;
            this.showFitness = false;
            this.showInsurance = false;
          } else {
            this.showBasicInfo = false;
            this.showProfilePic = false;
            this.showDriversLicence = false;
            this.showRC = false;
            this.showPanOrAadhar = false;
            this.showMoreInfo = true;
            this.showPermit = false;
            this.showFitness = false;
            this.showInsurance = false;
          }
          break;
        case 6:
          this.showBasicInfo = false;
          this.showProfilePic = false;
          this.showDriversLicence = false;
          this.showRC = false;
          this.showPanOrAadhar = false;
          this.showMoreInfo = false;
          this.showPermit = false;
          this.showFitness = true;
          this.showInsurance = false;
          break;
        case 7:
          this.showBasicInfo = false;
          this.showProfilePic = false;
          this.showDriversLicence = false;
          this.showRC = false;
          this.showPanOrAadhar = false;
          this.showMoreInfo = false;
          this.showPermit = false;
          this.showFitness = false;
          this.showInsurance = true;
          break;
        case 8:
          this.showBasicInfo = false;
          this.showProfilePic = false;
          this.showDriversLicence = false;
          this.showRC = false;
          this.showPanOrAadhar = false;
          this.showMoreInfo = true;
          this.showPermit = false;
          this.showFitness = false;
          this.showInsurance = false;
          break;
      }
    }

  }


  goBack(stepper: MatStepper) {
    stepper.previous();
    // Refresh cab document data when navigating to cab document sections
    this.refreshCabDocumentsIfNeeded();
  }

  populateFitness(response) {
    if (response['fitness'] && response['fitness']['approvalInfo'] &&
      response['fitness']['approvalInfo']['approvedAt']) {
      this.isFitnessApproved = true;
    }
    if (response['fitness'] && response['fitness']['rejectionInfo'] &&
      response['fitness']['rejectionInfo']['front'] && response['fitness']['rejectionInfo']['front']['timestamp']) {
      this.isFitnessRejected = true;
    }
  }

  populatePermit(response) {
    if (response['permit'] && response['permit']['approvalInfo'] &&
      response['permit']['approvalInfo']['approvedAt']) {
      this.isPermitApproved = true;
    }
    if (response['permit'] && response['permit']['rejectionInfo'] &&
      response['permit']['rejectionInfo']['front'] && response['permit']['rejectionInfo']['front']['timestamp']) {
      this.isPermitRejected = true;
    }
  }

  populateInsurance(response) {
    if (response['insurance'] && response['insurance']['approvalInfo'] &&
      response['insurance']['approvalInfo']['approvedAt']) {
      this.isInsuranceApproved = true;
    }
    if (response['insurance'] && response['insurance']['rejectionInfo'] &&
      response['insurance']['rejectionInfo']['front'] && response['insurance']['rejectionInfo']['front']['timestamp']) {
      this.isInsuranceRejected = true;
    }
  }

  fetchCabData(riderId, number) {
    const result = this._onboardingService.getCabData(riderId, number).subscribe(
      response => {
        this.populateFitness(response);
        this.populatePermit(response);
        this.populateInsurance(response);
      },
      error => {
        const errorMessage = error && error.error && error.error.message || 'Could not fetch cab data';
        this._toastMessage.openSnackBarError(errorMessage);
      }
    );
  }

  fetchRcDefaulter(riderId) {
    const result = this._onboardingService.fetchRcDefaulter(riderId).subscribe(
      response => {
        this.rcDefaulter = response['defaulter'];
        this.rcDefaulterNumberChanged = response['rcNumberChanged'] ? response['rcNumberChanged'] : false;
        this.formDocStatusInfo();
      },
      error => {
        const errorMessage = error && error.error && error.error.message || 'Could not fetch balance';
        this._toastMessage.openSnackBarError(errorMessage);
      }
    );
  }



  approveAndProceed(stepper: MatStepper) {
    this.stepperValue += 20;
    this.isApproved.push(this.pageName);
    this._toastMessage.openSnackBarSuccess(this.pageName.toString() + ' is approved!');
    if (this.stepperValue === 100) {

      this._toastMessage.openSnackBarSuccess('Done! You can now review the data and proceed.');
    }
    stepper.next();
  }

  logout() {
    document.cookie = ' ';
    localStorage.removeItem('userId');
    localStorage.removeItem('token');
    localStorage.removeItem('permissions');
    document.cookie = 'token= ; expires = Thu, 01 Jan 1970 00:00:00 GMT';

    this._toastMessage.openSnackBarSuccess('You have been logged out');
    if (window['fcWidget']) {
      window['fcWidget'].destroy();
    }
    this.router.navigate(['/']);

  }

  goForward(stepper: MatStepper) {
    stepper.next();
    // Refresh cab document data when navigating to cab document sections
    this.refreshCabDocumentsIfNeeded();
  }

  dlViewToggle(evt) {
    if (!evt.checked) {
      this.showDLBack = true;
      this.showDLFront = false;
    }

    if (evt.checked) {
      this.showDLBack = false;
      this.showDLFront = true;
    }
    console.log(this.showDLRejectIcon);

  }

  rcViewToggle(evt) {
    if (!evt.checked) {
      this.showRCBack = true;
      this.showRCFront = false;
    }

    if (evt.checked) {
      this.showRCBack = false;
      this.showRCFront = true;
    }

  }

  panOrAadharViewToggle(evt) {
    if (!evt.checked && !this.isAadharOtpRequired && !this.isAadharBackOptional) {
      this.showPanBack = false;
      this.showPanFront = true;
      this.showAadharBack = true;
      this.showAadharFront = false;
    }

    if (evt.checked) {
      this.showPanBack = false;
      this.showPanFront = true;
      this.showAadharBack = false;
      this.showAadharFront = true;
    }

  }

  backToRidersList() {
    this.router.navigate(['/riders']);
  }

  backToSearchPage() {
    this.router.navigate(['/search']);
  }

  checkDataForFleet(item: any) {
    if (item.vehiclesAssignable.length > 1) {
      this.vehicleData = item.vehiclesAssignable[item.vehiclesAssignable.length - 1];

    }
    if (item.vehiclesAssignable.length === 1) {
      this.vehicleData = item.vehiclesAssignable[0];
    }
    if (this.vehicleData && this.vehicleData.id && this.vehicleData.id.rc) {
      if (this.vehicleData.id.rc.verified === true) {
        this.approvedPages.push('showRC');
      }
    }
  }

  checkData(item: any) {
    if (item.vehiclesAssignable.length > 1) {
      this.vehicleData = item.vehiclesAssignable[item.vehiclesAssignable.length - 1];

    }
    if (item.vehiclesAssignable.length === 1) {
      this.vehicleData = item.vehiclesAssignable[0];

    }
    if ((item.firstName && (item.firstName.length > 0))
      && (item.mobile && (item.mobile.length > 0))
      && (item.email && (item.email.length > 0))
      && (item.userId.otp)) {
      this.approvedPages.push('showBasicInfo');
    }
    if (item.profilePicture && item.profilePicture.verified === true) {
      this.approvedPages.push('showProfilePic');
    }
    if (item.license && item.license.verified === true) {
      this.approvedPages.push('showDriversLicence');
    }
    if (this.vehicleData && this.vehicleData.id && this.vehicleData.id.rc) {
      if (this.vehicleData.id.rc.verified === true) {
        this.approvedPages.push('showRC');
      }
    }
    if ((item.panCard && item.panCard.verified === true) || (item.aadhar && item.aadhar.verified === true)) {
      this.approvedPages.push('showPanOrAadhar');
    }
  }

  handleFetchData(evt: any) {
    this.reloadRiderData();
  }

  reloadRiderData() {
    if (this.fleetId && this.fleetNumber && this.fleetMode) {
      this.getFleetVehicleData(this.fleetId, this.fleetNumber, this.fleetMode, this.fleetModeId);
    } else {
      this.getRiderData(this.riderId);
    }
    this._changeDetector.detectChanges();
    if (document.getElementById('BlowupLens')) {
      if (window) {
        const blowupLens = document.getElementById('BlowupLens');
        if (blowupLens) {
          blowupLens.style.display = 'none';
        }
      }
    }
  }

  refreshCabDocumentsIfNeeded() {
    // Add a small delay to ensure stepper navigation is complete
    setTimeout(() => {
      // Check if any cab document sections are currently visible and refresh their data
      if (this.showPermit || this.showFitness || this.showInsurance) {
        // Refresh cab data for the current rider/fleet
        if (this.isFleetOnboarding && this.fleetId && this.fleetNumber) {
          this.fetchCabData(this.fleetId, this.fleetNumber);
        } else if (this.riderId) {
          this.fetchCabData(this.riderId, "");
        }

        // Force change detection to update the UI
        this._changeDetector.detectChanges();
      }
    }, 100);
  }

  setProfileStatus(verified, rejectRemarks, status) {
    if (verified) {
      this.ppVerified = true;
    } else if (
      !verified && (status === 'rejected' || rejectRemarks)
    ) {
      this.ppVerified = false;
      this.showPPRejectIcon = true;
    } else if (!verified) { this.ppVerified = false; }
  }

  setDlStatus(verified, rejectRemarks, status) {
    if (verified) {
      this.dlVerified = true;
    } else if (
      !verified && (status === 'rejected' || rejectRemarks)
    ) {
      this.dlVerified = false;
      this.showDLRejectIcon = true;
    } else if (!verified) {
      this.dlVerified = false;
      this.showDLRejectIcon = false;
    }
  }

  setRcStatus(verified, rejectRemarks, status) {
    if (verified) {
      this.rcVerified = true;
    } else if (
      !verified && (status === 'rejected' || rejectRemarks)
    ) {
      this.rcVerified = false;
      this.showRCRejectIcon = true;
    } else if (!verified) {
      this.rcVerified = false;
      this.showRCRejectIcon = false;
    }
  }

  setImageOptionalFlag(rc) {
    this.isImageOptional = !!(rc && rc.isImageOptional);
  }

  private getDocumentStatus(doc, verified = false): string {
    if (!doc) {
      return '';
    }
    if (verified) {
      return 'approved';
    }
    if (doc.status) {
      return doc.status;
    }
    if (doc.rejectRemarks || doc.rejecteRemarks) {
      return 'rejected';
    }
    return '';
  }

  private normalizeDocumentStatus(status: string): string {
    return (status || '').toLowerCase();
  }

  private getRcRoadTaxEditRestrictionConfig(config: any = {}): any {
    const defaultConfig = this.defaultRcRoadTaxEditRestrictionConfig;
    return {
      enabled: config.enabled !== undefined ? !!config.enabled : defaultConfig.enabled,
      documents: Object.assign({}, defaultConfig.documents, config.documents || {}),
      mutualEditableStatuses: Array.isArray(config.mutualEditableStatuses)
        ? config.mutualEditableStatuses
        : defaultConfig.mutualEditableStatuses,
      selfEditable: Array.isArray(config.selfEditable)
        ? config.selfEditable
        : defaultConfig.selfEditable,
      counterpartBlocking: Array.isArray(config.counterpartBlocking)
        ? config.counterpartBlocking
        : defaultConfig.counterpartBlocking,
      blockedMessage: config.blockedMessage || defaultConfig.blockedMessage
    };
  }

  private getActiveRcRoadTaxEditRestrictionConfig(): any {
    return this.rcRoadTaxEditRestrictionConfig || this.defaultRcRoadTaxEditRestrictionConfig;
  }

  private isStatusInConfigList(status: string, configKey: string): boolean {
    const normalizedStatus = this.normalizeDocumentStatus(status);
    const config = this.getActiveRcRoadTaxEditRestrictionConfig();
    const statuses = Array.isArray(config[configKey]) ? config[configKey] : [];
    return statuses
      .map((item) => this.normalizeDocumentStatus(item))
      .indexOf(normalizedStatus) !== -1;
  }

  private canEditDocumentWithCounterpartStatus(documentStatus: string, counterpartStatus: string): boolean {
    const config = this.getActiveRcRoadTaxEditRestrictionConfig();
    if (config.enabled === false) {
      return true;
    }
    if (this.isStatusInConfigList(documentStatus, 'selfEditable')) {
      return true;
    }
    if (
      this.isStatusInConfigList(documentStatus, 'mutualEditableStatuses')
      && this.isStatusInConfigList(counterpartStatus, 'mutualEditableStatuses')
    ) {
      return true;
    }
    if (this.isStatusInConfigList(counterpartStatus, 'counterpartBlocking')) {
      return false;
    }
    return true;
  }

  private formatDocumentStatus(status: string): string {
    if (!status) {
      return '';
    }
    return status
      .replace(/_/g, ' ')
      .replace(/\b\w/g, (char) => char.toUpperCase());
  }

  private getConfiguredDocumentLabel(documentKey: string): string {
    const config = this.getActiveRcRoadTaxEditRestrictionConfig();
    const defaultDocuments = this.defaultRcRoadTaxEditRestrictionConfig.documents;
    const documents = config.documents || {};
    return documents[documentKey] || defaultDocuments[documentKey] || documentKey;
  }

  private getDocumentEditBlockerMessage(sourceKey: string, sourceStatus: string, targetKey: string): string {
    const config = this.getActiveRcRoadTaxEditRestrictionConfig();
    const sourceLabel = this.getConfiguredDocumentLabel(sourceKey);
    const targetLabel = this.getConfiguredDocumentLabel(targetKey);
    return (config.blockedMessage || this.defaultRcRoadTaxEditRestrictionConfig.blockedMessage)
      .replace(/\{sourceLabel\}/g, sourceLabel)
      .replace(/\{sourceStatus\}/g, this.formatDocumentStatus(sourceStatus))
      .replace(/\{targetLabel\}/g, targetLabel);
  }

  canEditRcDocument(): boolean {
    return this.canEditDocumentWithCounterpartStatus(this.rcDocumentStatus, this.roadTaxDocumentStatus);
  }

  canEditRoadTaxDocument(): boolean {
    return this.canEditDocumentWithCounterpartStatus(this.roadTaxDocumentStatus, this.rcDocumentStatus);
  }

  getRcEditBlockerMessage(): string {
    if (this.canEditRcDocument()) {
      return '';
    }
    return this.getDocumentEditBlockerMessage('roadTax', this.roadTaxDocumentStatus, 'rc');
  }

  getRoadTaxEditBlockerMessage(): string {
    if (this.canEditRoadTaxDocument()) {
      return '';
    }
    return this.getDocumentEditBlockerMessage('rc', this.rcDocumentStatus, 'roadTax');
  }

  setAadhaarOtpRequiredFlag(aadhar) {
    this.isAadharOtpRequired = !!(aadhar && aadhar.isOtpRequired);
  }

  setAadharBackOptionalFlag(aadhar) {
    this.isAadharBackOptional = !!(aadhar && aadhar.isAadharBackOptional);
  }

  setPanStatus(verified, rejectRemarks, status) {
    if (verified) {
      this.panVerified = true;
    } else if (
      !verified && (status === 'rejected' || rejectRemarks)
    ) {
      this.panVerified = false;
      this.showPanRejectIcon = true;
    } else if (!verified) {
      this.panVerified = false;
      this.showPanRejectIcon = false;
    }
  }

  setAadharStatus(verified, rejectRemarks, status) {
    if (verified) {
      this.aadharVerified = true;
    } else if (
      !verified && (status === 'rejected' || rejectRemarks)
    ) {
      this.aadharVerified = false;
      this.showAadharRejectIcon = true;
    } else if (!verified) {
      this.aadharVerified = false;
      this.showAadharRejectIcon = false;
    }
  }

  setRoadTaxStatus(verified, rejectRemarks, status) {
    if (verified) {
      this.roadTaxVerified = true;
    } else if (
      !verified && (status === 'rejected' || rejectRemarks)
    ) {
      this.roadTaxVerified = false;
      this.showRoadTaxRejectIcon = true;
    } else if (!verified) {
      this.roadTaxVerified = false;
      this.showRoadTaxRejectIcon = false;
    }
  }

  ppStatusUpdate(evt: any) {
    if (evt === false) {
      this.setProfileStatus(evt, 'rejected', 'rejected');
    } else if (evt === true) {
      this.setProfileStatus(evt, '', 'approved');
    }
    this.data.profilePicture.verified = evt;
  }

  dlStatusUpdate(evt: any) {
    if (evt === false) {
      this.setDlStatus(evt, 'rejected', 'rejected');
    } else if (evt === true) {
      this.setDlStatus(evt, '', 'approved');
    }
    this.data.license.verified = evt;
  }

  rcStatusUpdate(evt: any) {
    if (evt === false) {
      this.rcDocumentStatus = 'rejected';
      this.setRcStatus(evt, 'rejected', 'rejected');
    } else if (evt === true) {
      this.rcDocumentStatus = 'approved';
      this.setRcStatus(evt, '', 'approved');
    }

    if (
      this.data.vehiclesAssignable[0] && this.data.vehiclesAssignable[0].id
      && this.data.vehiclesAssignable[0].id && this.data.vehiclesAssignable[0].id.rc
    ) {
      this.data.vehiclesAssignable[0].id.rc.verified = evt;
    }
  }

  panStatusUpdate(evt: any) {
    if (evt === false) {
      this.setPanStatus(evt, 'rejected', 'rejected');
    } else if (evt === true) {
      this.setPanStatus(evt, '', 'approved');
    }
    this.data.panCard.verified = evt;
  }

  aadharStatusUpdate(evt: any) {
    if (evt === false) {
      this.setAadharStatus(evt, 'rejected', 'rejected');
    } else if (evt === true) {
      this.setAadharStatus(evt, '', 'approved');
    }
    this.data.aadhar.verified = evt;
  }

  roadTaxStatusUpdate(evt: any) {
    if (evt === false) {
      this.roadTaxDocumentStatus = 'rejected';
      this.setRoadTaxStatus(evt, 'rejected', 'rejected');
      this.isRoadTaxRejected = true;
    } else if (evt === true) {
      this.roadTaxDocumentStatus = 'approved';
      this.setRoadTaxStatus(evt, '', 'approved');
      this.isRoadTaxRejected = false;
    }
    if (this.data.roadTax) {
      this.data.roadTax.verified = evt;
    }
  }

  handleRiderActive(evt: any) {
    this.showActive = evt;
  }

  storeLicenseData(evt) {
    this.licenseData['drivingLicense'] = evt;
    if (this.canShowVerifyButtons()) {
      this.showDLVerify = true;
    }
  }

  storeDlImageUrl(evt) {
    this.dlVerified = false;
    this.showDLRejectIcon = false;
    this.licenseData['dlImage'] = evt;
    if (this.canShowVerifyButtons()) {
      this.showDLVerify = true;
    }
  }

  storeRc(evt) {
    this.rcVerified = false;
    this.showRCRejectIcon = false;
  }

  storeDlBack(evt) {
    this.dlVerified = false;
    this.showDLRejectIcon = false;
    this.licenseData['dlBackImage'] = evt;
  }

  storeVehicleNumber(evt) {
    this.vehicleRegistrationData['registrationNumber'] = evt;
    if (this.canShowVerifyButtons()) {
      this.showRCVerify = true;
      // Show RoadTax verify button only if RoadTax number is present
      const roadTaxVehicleNumber = this.getRoadTaxVehicleNumber();
      this.showRoadTaxVerify = !!roadTaxVehicleNumber;
    }
  }

  storePanNumber(event) {
    this.pan['number'] = event;
    if (this.canShowVerifyButtons()) {
      this.showPanVerify = true;
    }
  }

  storeAadharNumber(event) {
    this.aadhar['number'] = event;
    if (this.canShowVerifyButtons()) {
      this.showAadharVerify = true;
    }
  }

  storePanImage(event) {
    this.panVerified = false;
    this.showPanRejectIcon = false;
    this.pan['link'] = event;
  }

  storeAadharFrontImage(event) {
    this.aadharVerified = false;
    this.showAadharRejectIcon = false;
    this.aadhar['frontLink'] = event;
  }

  storeAadharBackImage(event) {
    this.aadharVerified = false;
    this.showAadharRejectIcon = false;
    this.aadhar['backLink'] = event;
  }

  storeProfileData(evt) {
    this.ppVerified = false;
    this.showPPRejectIcon = false;
    this.profileData = {
      'profileImage': evt
    };
    if (this.canShowVerifyButtons()) {
      this.showPPVerify = true;
    }
  }

  birthDateUpdate(evt) {
    this.basicInfo = {
      'birthDate': evt
    };
  }

  licenseDobUpdate(dob: string | null) {
    const date = dob ? new Date(dob) : null;
    this.licenseData['birthDate'] = date && date.getFullYear() !== 1 ? date : '';
  }

  modeUpdate(evt) {
    this.reloadRiderData();
  }

  async typeUpdate(type) {
    // Check if mode is 'auto' AND type is 'e-rickshaw' (or 'Erickshaw')
    const currentMode = this.data && this.data.modeId && this.data.modeId.mode;
    this.isErickshawType = (currentMode === 'Auto' && type === 'Erickshaw');
    await this.fetchTypeConfig();

    // No DL captains are not meant to have services. If the captain already had
    // services assigned (e.g. converted from a regular captain), strip them so the
    // rider state stays consistent with the No DL type.
    if (type === 'noDl') {
      this.removeServicesForNoDlType();
    }
  }

  removeServicesForNoDlType() {
    
    const preferences = this.userpreferences
      && this.userpreferences.data
      && this.userpreferences.data.serviceTypePreferences;
    const activeServices = (preferences && preferences.activeServices) || [];
    const serviceDetailIds = Array.from(new Set(
      activeServices
        .reduce((ids, group) => ids.concat((group && group.serviceDetailIds) || []), [])
        .filter(Boolean)
    ));
    if (!serviceDetailIds.length) {
      return;
    }
    const userId = this.data._id;
    const city = (this.data.city && this.data.city._id) ? this.data.city._id : this.data.city;
    this._onboardingService.removeService(userId, serviceDetailIds, city).subscribe(
      () => {
        this.reloadRiderData();
      },
      (error) => {
        const errorMessage =
          (typeof error === 'string' && error)
          || (error && error.error && error.error.message)
          || (error && error.message)
          || 'Could not remove existing services for B2B captain';
        this._toastMessage.openSnackBarError(errorMessage);
      }
    );
  }

  async fetchTypeConfig() {
    if (!this.data) {
      this.optionalDocs = [];
      this.rcRoadTaxEditRestrictionConfig = this.getRcRoadTaxEditRestrictionConfig();
      return;
    }
    const cityId = this.data.city && this.data.city._id || this.data.city;
    const modeName = this.data.modeId && this.data.modeId.mode || '';

    if (!cityId || !modeName) {
      this.optionalDocs = [];
      this.rcRoadTaxEditRestrictionConfig = this.getRcRoadTaxEditRestrictionConfig();
      return;
    }

    try {
      const response: any = await this._onboardingService.getTypeConfig(cityId, modeName);

      if (response && response.success && response.data) {
        const config = response.data;
        this.optionalDocs = Array.isArray(config.optionalDocs) ? config.optionalDocs : [];
        this.rcRoadTaxEditRestrictionConfig = this.getRcRoadTaxEditRestrictionConfig(config.rcRoadTaxEditRestriction);
      } else {
        this.optionalDocs = [];
        this.rcRoadTaxEditRestrictionConfig = this.getRcRoadTaxEditRestrictionConfig();
      }
    } catch {
      this.optionalDocs = [];
      this.rcRoadTaxEditRestrictionConfig = this.getRcRoadTaxEditRestrictionConfig();
    }
  }

  isDocOptional(docKey: string): boolean {
    const key = String(docKey).toLowerCase();

    if (key === 'dl' && this.isEarlyActivationEnabled && this.isBikePinkEarlyActivationV2) {
      return this.isDrivingLicenseOptionalInEarlyActivation;
    }

    // No DL captains: Driver's License and Registration Card are optional.
    const isNoDlType = this.data && this.data.type === 'noDl';
    if (isNoDlType && (key === 'dl' || key === 'rc')) {
      return true;
    }

    if (!this.isErickshawType || !this.optionalDocs || this.optionalDocs.length === 0) {
      return false;
    }
    return this.optionalDocs.some(d => String(d).toLowerCase() === key);
  }

  firstNameUpdate(evt) {
    this.basicInfo = {
      'firstName': evt
    };
  }
  userPreferences(evt) {
    this.userpreferences = evt;
  }

  // Inactive captains, or active noDl captains, may show verify buttons
  canShowVerifyButtons(rider = this.data): boolean {
    return !!(rider && (!rider.active || rider.type === 'noDl'));
  }

  // enable verify button based on the status ( Accepted, Warning)
  verifyStatus(docStatus) {
    const verificationStatus = docStatus['docVerificationStatus'] || {};
    const approvalStatus = docStatus['autoApprovalStatus'] || {};
    const dlStatus = verificationStatus['license'] || {};
    const ppStatus = verificationStatus['profilePic'] || {};
    const rcStatus = verificationStatus['vehicleRegistration'] || {};
    const roadTaxStatus = verificationStatus['roadTax'] || {};
    const panStatus = verificationStatus['pan'] || {};
    const aadharStatus = verificationStatus['aadhar'] || {};

    const dlAutoApproval = approvalStatus.licenseVerificationStatus || {};
    const ppAutoApproval = approvalStatus.profileVerificationStatus || {};
    const rcAutoApproval = approvalStatus.vehicleVerificationStatus || {};
    const roadTaxAutoApproval = approvalStatus.roadTaxVerificationStatus || {};
    const panAutoApproval = approvalStatus.panVerificationStatus || {};
    const aadharAutoApproval = approvalStatus.aadharVerificationStatus || {};

    const vehicleData = rcStatus && rcStatus.owner && rcStatus.fitnessUpto ? true : false;
    if (dlStatus.status === this.verificationStatus.ACCEPTED || dlStatus.status === this.verificationStatus.VERIFIED || dlAutoApproval.autoApproved) {
      this.showDLVerify = false;
    } else {
      this.showDLVerify = true;
    }
    if (ppStatus.status === this.verificationStatus.ACCEPTED || ppStatus.status === this.verificationStatus.VERIFIED || ppAutoApproval.autoApproved) {
      this.showPPVerify = false;
    } else {
      this.showPPVerify = true;
    }
    if (
      rcStatus.status === this.verificationStatus.ACCEPTED
      || rcStatus.status === this.verificationStatus.VERIFIED
      || rcAutoApproval.autoApproved
    ) {
      this.showRCVerify = false;
    } else {
      this.showRCVerify = true;
    }
    if (rcStatus.status && !vehicleData) {
      this.showVerifyButton = true;
    }

    // Show verify button for RoadTax only if RoadTax number is present
    const roadTaxVehicleNumber = this.getRoadTaxVehicleNumber();
    if (roadTaxStatus.status === this.verificationStatus.ACCEPTED ||
      roadTaxStatus.status === this.verificationStatus.VERIFIED ||
      roadTaxAutoApproval.autoApproved ||
      !roadTaxVehicleNumber) {
      this.showRoadTaxVerify = false;
    } else {
      this.showRoadTaxVerify = true;
    }

    if (panStatus.status === this.verificationStatus.ACCEPTED ||
      panStatus.status === this.verificationStatus.VERIFIED ||
      panAutoApproval.autoApproved) {
      this.showPanVerify = false;
    } else {
      this.showPanVerify = true;
    }

    if (aadharStatus.status === this.verificationStatus.ACCEPTED ||
      aadharStatus.status === this.verificationStatus.VERIFIED || aadharAutoApproval.autoApproved) {
      this.showAadharVerify = false;
    } else {
      this.showAadharVerify = true;
    }
  }

  validateProfileDlBody({
    drivingLicense, dlImage, dlBackImage, birthDate, profileImage, userId, actorId,
    actorType, triggeredFrom, name
  }) {

    if (!dlImage) {
      this._toastMessage.openSnackBarError('Please upload Dl front image for verification.');
      this.spinnerService.hide();
      return false;
    }

    if (!dlBackImage) {
      this._toastMessage.openSnackBarError('Please upload Dl back image for verification.');
      this.spinnerService.hide();
      return false;
    }

    if (!drivingLicense) {
      this._toastMessage.openSnackBarError('Please enter Dl number for verification.');
      this.spinnerService.hide();
      return false;
    }

    if (!profileImage) {
      this._toastMessage.openSnackBarError('Please upload profile picture for verification.');
      this.spinnerService.hide();
      return false;
    }

    if (!birthDate) {
      this._toastMessage.openSnackBarError('Please enter date of birth for verification.');
      this.spinnerService.hide();
      return false;
    }

    if (!name) {
      this._toastMessage.openSnackBarError('Please enter name for verification.');
      this.spinnerService.hide();
      return false;
    }

    return true;
  }

  // Call DL, PP API to verify the uploaded docs
  verifyProfileDLDocs(event) {
    // required details to verify profile pic and DL.
    const profileDlInfo = this.createDlInfo(event);
    this.spinnerService.show();
    if (this.validateProfileDlBody(profileDlInfo)) {
      this.dlNumber = profileDlInfo.drivingLicense || null;
      this._toastMessage.openSnackBarSuccess('Verifying details from Government Server');
      this.showDLVerify = false;
      this._onboardingService.verifyProfileDLDocs(profileDlInfo).subscribe(response => {
        this.spinnerService.hide();
        if (response && response['data'] && response['data']['status'] === 'success') {

          const docStatus = response['data'];

          this.createProfileStatus(docStatus);
          this.createDlStatus(docStatus);
          this.verifyStatus(docStatus);
          this._toastMessage.openSnackBarSuccess(response['data']['data']);

        } else {
          this.showDLVerify = true;
          if (response && response['data'] && response['data'] && response['data']['message']) {
            this._toastMessage.openSnackBarError(response['data']['message']);
          } else {
            this._toastMessage.openSnackBarError('Faced problem in verification of docs');
          }
        }
      }, err => {
        this.spinnerService.hide();
        this.showDLVerify = true;
        this._toastMessage.openSnackBarError(err);
      });

    }
  }

  // Call Rc API to verify the uploaded docs
  verifyRcDoc(event) {
    // Don't show spinner here - let verification-status component handle it
    if (
      this.vehicleRegistrationData
      && this.vehicleRegistrationData['registrationNumber']
    ) {

      let docVerificationDetails = {};
      this.vehicleNumber = this.vehicleRegistrationData['registrationNumber'];

      docVerificationDetails = this.createRcInfo();
      this.showRCVerify = false;
      this._toastMessage.openSnackBarSuccess('Fetching details from Government Server');
      this._onboardingService.verifyRcDoc(docVerificationDetails).subscribe(response => {
        this.spinnerService.hide();

        if (response && response['data'] && response['data']['status'] === 'success') {
          const docStatus = response['data'];
          this.createRcStatus(docStatus);

          this.verifyStatus(docStatus);

          this._toastMessage.openSnackBarSuccess(response['data']['data']);
        } else {
          console.error(response);
          if (response && response['data'] && response['data']) {
            this._toastMessage.openSnackBarError(response['data']);
          } else {
            this._toastMessage.openSnackBarError('Faced problem in verification of docs');
          }
        }
      }, err => {
        this.spinnerService.hide();
        console.log('Error : ', err);
        this._toastMessage.openSnackBarError(err);
      });
    } else {
      this.spinnerService.hide();
      this._toastMessage.openSnackBarError('Please enter vehicle number for verification.');
    }
  }

  // Call RoadTax API to verify the uploaded docs
  verifyRoadTaxDoc(event) {
    this.spinnerService.show();
    const roadTaxVehicleNumber = this.getRoadTaxVehicleNumber();
    if (roadTaxVehicleNumber) {
      let docVerificationDetails = {};
      this.vehicleNumber = roadTaxVehicleNumber;

      docVerificationDetails = this.createRoadTaxInfo();
      this.showRoadTaxVerify = false;
      this._toastMessage.openSnackBarSuccess('Fetching details from Government Server');
      this._onboardingService.verifyRoadTaxDoc(docVerificationDetails).subscribe(response => {
        this.spinnerService.hide();

        if (response && response['data'] && response['data']['status'] === 'success') {
          const docStatus = response['data'];
          // The response might have roadTax data directly or in a nested structure
          const roadTaxData = docStatus['roadTax'] || docStatus['data'] || {};
          this.createRoadTaxStatus(roadTaxData);

          this.verifyStatus(docStatus);

          this._toastMessage.openSnackBarSuccess(response['data']['data']);
        } else {
          console.error(response);
          if (response && response['data'] && response['data']) {
            this._toastMessage.openSnackBarError(response['data']);
          } else {
            this._toastMessage.openSnackBarError('Faced problem in verification of docs');
          }
        }
      }, err => {
        this.spinnerService.hide();
        console.log('Error : ', err);
        this._toastMessage.openSnackBarError(err);
      });
    } else {
      this.spinnerService.hide();
      this._toastMessage.openSnackBarError('Please enter vehicle number for verification.');
    }
  }

  createRoadTaxInfo() {
    const docVerificationDetails = {};
    const roadTaxVehicleNumber = this.getRoadTaxVehicleNumber();
    docVerificationDetails['registrationNumber'] = roadTaxVehicleNumber;
    docVerificationDetails['userId'] = this.data._id ? this.data._id : '';
    docVerificationDetails['actorId'] = this.actorId;
    docVerificationDetails['actorType'] = this.ACTORTYPE.AGENT;
    // Get isImageOptional from roadTax data
    const isRoadTaxImageOptional = !!(this.data && this.data.roadTax && this.data.roadTax.info && this.data.roadTax.info.isImageOptional);
    docVerificationDetails['isImageOptional'] = isRoadTaxImageOptional;

    return docVerificationDetails;
  }

  getRoadTaxVehicleNumber(): string {
    // Get RoadTax vehicle number from data
    if (this.data && this.data.roadTax) {
      const roadTax = this.data.roadTax;
      if (roadTax.number) {
        return roadTax.number;
      }
      if (roadTax.vehicleNumber) {
        return roadTax.vehicleNumber;
      }
    }
    return '';
  }

  createDlInfo(triggeredFrom) {
    const profileDlInfo: {
      drivingLicense
      dlImage
      dlBackImage
      birthDate
      profileImage
      userId
      actorId
      actorType
      triggeredFrom,
      name
    } = {
      drivingLicense: '',
      dlImage: '',
      dlBackImage: '',
      birthDate: '',
      profileImage: '',
      userId: '',
      actorId: '',
      actorType: '',
      triggeredFrom: '',
      name: ''
    };
    profileDlInfo.drivingLicense = this.licenseData['drivingLicense'];
    profileDlInfo.dlImage = this.licenseData['dlImage'];
    profileDlInfo.dlBackImage = this.licenseData['dlBackImage'];
    profileDlInfo.birthDate = this.licenseData['birthDate'];
    profileDlInfo.profileImage = this.profileData['profileImage'];
    profileDlInfo.name = this.basicInfo['firstName'];

    profileDlInfo.userId = this.data._id || ''; // captain Id
    profileDlInfo.actorId = this.actorId;
    profileDlInfo.actorType = this.ACTORTYPE.AGENT;
    profileDlInfo.triggeredFrom = triggeredFrom;

    return profileDlInfo;
  }

  createRcInfo() {
    const docVerificationDetails = {};

    docVerificationDetails['registrationNumber'] = this.vehicleRegistrationData['registrationNumber'];
    docVerificationDetails['userId'] = this.data._id ? this.data._id : '';
    docVerificationDetails['actorId'] = this.actorId;
    docVerificationDetails['actorType'] = this.ACTORTYPE.AGENT;
    docVerificationDetails['isImageOptional'] = this.isImageOptional;

    return docVerificationDetails;
  }

  createPanInfo() {
    this.panVerificationDetails['number'] = this.pan['number'];
    this.panVerificationDetails['link'] = this.pan['link'];
    this.panVerificationDetails['actorId'] = this.actorId;
    this.panVerificationDetails['actorType'] = this.ACTORTYPE.AGENT;

  }

  createAadharInfo() {
    this.aadharVerificationDetails['number'] = this.aadhar['number'];
    this.aadharVerificationDetails['frontLink'] = this.aadhar['frontLink'];
    this.aadharVerificationDetails['backLink'] = this.aadhar['backLink'];
    this.aadharVerificationDetails['actorId'] = this.actorId;
    this.aadharVerificationDetails['actorType'] = this.ACTORTYPE.AGENT;
  }

  createProfileStatus(docStatus) {
    const pp = docStatus['profilePic'] || {};
    const profileStatus = pp.status === this.verificationStatus.ACCEPTED ? this.verificationStatus.VERIFIED : pp.status;
    const isProfileAccepted = pp.status === this.verificationStatus.ACCEPTED ? true : false;
    const message = pp.message || '';
    const profileLink = pp.data && pp.data.profileLink || '';
    const verifiedBy = pp.verifiedBy || '';
    const verifiedOn = pp.verifiedOn || '';

    this.profileStatus = {
      status: profileStatus, profileLink: profileLink, message: message,
      isProfileAccepted: isProfileAccepted,
      verifiedBy: verifiedBy,
      verifiedOn: verifiedOn
    };
  }

  createDlStatus(docStatus) {

    const dl = docStatus['license'] || {};
    const dlStatus = dl.status === this.verificationStatus.ACCEPTED ? this.verificationStatus.VERIFIED : dl.status;
    const isDlAccepted = dl.status === this.verificationStatus.ACCEPTED ? true : false;
    const message = dl.message || '';
    const expiryDate = dl && dl['data'] && dl['data'].expiryDate || '';
    const verifiedBy = dl.verifiedBy || '';
    const verifiedOn = dl.verifiedOn || '';

    this.licenseStatus = {
      status: dlStatus, expiryDate: expiryDate, message: message,
      isDlAccepted: isDlAccepted,
      verifiedBy: verifiedBy,
      verifiedOn: verifiedOn
    };
  }

  createRcStatus(docStatus) {
    const rc = docStatus['vehicleRegistration'] || {};
    const rcStatus = rc.status === this.verificationStatus.ACCEPTED ? this.verificationStatus.VERIFIED : rc.status;
    const isRcAccepted = rc.status === this.verificationStatus.ACCEPTED ? true : false;
    const message = rc.message || '';
    const rcData = rc['data'] || {};
    const verifiedBy = rc.verifiedBy || '';
    const verifiedOn = rc.verifiedOn || '';

    this.vehicleRegStatus = {
      data: rcData, status: rcStatus, message: message,
      isRcAccepted: isRcAccepted,
      verifiedBy: verifiedBy,
      verifiedOn: verifiedOn
    };
  }

  createRoadTaxStatus(roadTaxData) {
    const roadTax = roadTaxData || {};
    const verificationInfo = roadTax.verificationInfo || {};
    const roadTaxStatus = verificationInfo.status === this.verificationStatus.ACCEPTED ? this.verificationStatus.VERIFIED : verificationInfo.status;
    const isRoadTaxAccepted = verificationInfo.status === this.verificationStatus.ACCEPTED ? true : false;
    const message = verificationInfo.message || '';
    const roadTaxDataObj = {}; // RoadTax doesn't have data object like RC
    const verifiedBy = verificationInfo.verifiedBy || '';
    const verifiedOn = verificationInfo.verifiedOn || '';

    this.roadTaxRegStatus = {
      data: roadTaxDataObj, status: roadTaxStatus, message: message,
      isRoadTaxAccepted: isRoadTaxAccepted,
      verifiedBy: verifiedBy,
      verifiedOn: verifiedOn
    };
  }

  updateShowVehicleNumberChangeToggle(evt) {
    this.showVehicleNumberChangeToggle = evt;
  }

  permitApproved(evt) {
    this.isPermitApproved = true;
    this.isPermitRejected = false;
    if (evt === false) {
      this.isPermitApproved = false;
    }
  }

  permitRejected(evt) {
    this.isPermitApproved = false;
    this.isPermitRejected = true;
    if (evt === false) {
      this.isPermitRejected = false;
    }
  }

  fitnessApproved(evt) {
    this.isFitnessApproved = true;
    this.isFitnessRejected = false;
    if (evt === false) {
      this.isFitnessApproved = false;
    }
  }

  fitnessRejected(evt) {
    this.isFitnessApproved = false;
    this.isFitnessRejected = true;
    if (evt === false) {
      this.isFitnessRejected = false;
    }
  }

  insuranceApproved(evt) {
    this.isInsuranceApproved = true;
    this.isInsuranceRejected = false;
    if (evt === false) {
      this.isInsuranceApproved = false;
    }
  }

  insuranceRejected(evt) {
    this.isInsuranceApproved = false;
    this.isInsuranceRejected = true;
    if (evt === false) {
      this.isInsuranceRejected = false;
    }
  }

  // createPanStatus(docStatus) {
  //   const pan = docStatus['panCard'] || {};
  //   if (pan.status) {
  //     const panStatus = pan.status === this.verificationStatus.ACCEPTED ? this.verificationStatus.VERIFIED : pan.status;
  //     const isPanAccepted = pan.status === this.verificationStatus.ACCEPTED;
  //     const message = pan.message || '';
  //     const panData = pan['data'] || {};

  //     this.panStatus = { data : panData, status: panStatus, message: message,
  //       isPanAccepted: isPanAccepted,
  //       // verifiedBy: verifiedBy,
  //       // verifiedOn: verifiedOn
  //     };
  //   }
  // }

  // createAadharStatus(docStatus) {
  // const aadhar = docStatus['aadhar'] || {};
  // if (aadhar.status) {
  //   const aadharStatus = aadhar.status === this.verificationStatus.ACCEPTED ? this.verificationStatus.VERIFIED : aadhar.status;
  //   const isAadharAccepted = aadhar.status === this.verificationStatus.ACCEPTED;
  //   const message = aadhar.message || '';
  //   const aadharData = aadhar['data'] || {};
  //   const verifiedBy = aadhar.verifiedBy || '';
  //   const verifiedOn = aadhar.verifiedOn || '';

  //   this.aadharStatus = { data : aadharData, status: aadharStatus, message: message,
  //     isAadharAccepted: isAadharAccepted,
  //     verifiedBy: verifiedBy,
  //     verifiedOn: verifiedOn
  //   };
  // }
  // }
}
